const applicationName = '/kiosk';
export const applicationRouteConstants = {
  DEFAULT: `${applicationName}`,
  LOGIN: `${applicationName}/login`,
  HUB: `${applicationName}/hub`,
  SiteInformation: `${applicationName}/site-information`,
};
